import React from 'react'
import { Link } from 'react-router-dom'

import { mobile, hd, hdd } from '../responsive'
import styled from 'styled-components'

const Container = styled.div`
    width: 100%;
    height: 12vh;
    display: flex;
`

const Left = styled.div`
    width: 20%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    ${mobile ({ width: "100%", justifyContent: "center" })}
`

const Right = styled.div`
    width: 80%;
    height: 80%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    ${mobile({ display: "none" })}
`

const Logo = styled.img`
    margin-left: 20%;
    width: 80%;
    height: 80%;
    object-fit: contain;

    &:hover {
        cursor: pointer;
    }

    ${mobile ({ width: "50%", height: "50%" })}
`

const Links = styled.ul`
    list-style-type: none;
    margin-right: 10%;
`

const LinkItem = styled.li`
    display: inline-block;
    padding: 15px;
    font-size: 17px;

    ${hd({ fontSize: "26px" })}
    ${hdd({ fontSize: "32px" })}
`

const Header = () => {
  return (
    <Container>
        <Left>
            <Link to="/">
                <Logo src='http://www.greenton.ba/wp-content/uploads/2023/03/gtpng.png' />
            </Link>
        </Left>

        <Right>
            <Links>
                <LinkItem><Link to="http://www.greenton.ba/" style={{textDecoration: "none", color: "inherit"}}>GreenTon</Link></LinkItem>
                <LinkItem><Link to="/ostali" style={{textDecoration: "none", color: "inherit"}}>Toneri</Link></LinkItem>
                <LinkItem><Link to="/kontakt" style={{textDecoration: "none", color: "inherit"}}>Kontakt</Link></LinkItem>
            </Links>
        </Right>
    </Container>
  )
}

export default Header